import axios from "axios";

const BASE_API_URL = "/api/divination";

//卦（文王聖卦／伏爻子）service
//
//  全部要登入 —— 問卦的入口是底部頁籤，那個頁籤本身就擋登入，
//  所以不存在「沒有帳號的人要查自己的卦」這個情境（跟白夜的報告相反）。
//
//  問卦券本身是在金流那邊買的（PaymentService.checkout 搭 type "gua"）；
//  這裡做的是「用掉一張券」。
class DivinationService {
  //D-1 我的卦（列表，一次十筆、新的在前）
  //
  //  回 { divinations, hasMore, nextBefore }。
  //  往回翻就把上一次的 nextBefore 原樣傳回去 —— 它是「比這個時刻更早的」。
  //
  //  為什麼不是 page 編號：兩頁之間使用者又問了一卦的話，整串會往後位移一格，
  //  第二頁會把第一頁的最後一筆再給一次（實測過，offset 真的會重複）。
  list(before) {
    return axios.get(`${BASE_API_URL}/list`, {
      params: before ? { before } : {},
    });
  }

  //D-2 單一卦
  get(divinationID) {
    return axios.get(`${BASE_API_URL}/${divinationID}`);
  }

  //D-3 問一卦：扣一張問卦券，建一筆卦
  //
  //  回 { divination, remain }。remain 是扣完之後剩幾張 ——
  //  帶回來前端就不用再打一次 /tickets（而且那樣有時序問題：
  //  兩支請求並行的話餘額可能顯示成扣之前的數字）。
  //
  //  沒券時後端回 status: false + 「沒有問卦券了」，呼叫端要導去購券分頁。
  //  前端也會先用餘額擋一次 —— 但那只是體驗，真正的把關在後端
  //  （前端的餘額可能是舊的，而且擋在前端的東西一律繞得過）。
  //
  //  question 送全文，不要在前端裁 —— 後端拿它取用神（六爻斷卦第一步），
  //  覆述動畫上的 50 字只是顯示用的。
  create(question) {
    return axios.post(BASE_API_URL, { question });
  }
}

const divinationService = new DivinationService();
export default divinationService;
